import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SmallshiService {
  public categoryId = '';
  public idTienda = '';
  public tlfTienda = '';
  public idCliente = '';
  public urlPau = '';
  public idJsonPau = '';
  public urlRetorno = '';
  public nombreCliente = '';
  public nombreTienda = '';
  public emailCliente = '';
  public telefonoCliente = '';
  public codigoPais = '';
  public codCliente = '';
  public flujo: string;
  public shiwallet: number;
  public etiquetaComercio = '';
  public mesaComercio: number;
  public validaMesa = false;
  public controlDelivery = 0;
  public idhentrega = '';
  public formaEntrega = '';
  public filtroHtml = '';
  public tienda_lat = 0;
  public tienda_lng = 0;
  public radioDelivery = 0;
  private DELIVERY: boolean
  private _getDatosTienda= new BehaviorSubject<object>({});
  getDatosTienda$ = this._getDatosTienda.asObservable()

  public urlBase = environment.urlBase;
  public idSDCC = '231'; // desa 283   // prod 231
  public urlReservas = environment.urlReservas;



  get delivery() {
    return this.DELIVERY
  }
  set delivery(id) {
    let data = !!parseInt((id as any))
    this.DELIVERY = data
  }

  constructor(private http: HttpClient) { }

  getQuery(query: string) {
    const url = this.urlBase + query;

    const headers = new HttpHeaders({
      'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
    });

    return this.http.get(url, { headers });
  }


  nextDatosTienda(data:object){
    this._getDatosTienda.next(data);
  }

  getTienda(idComercio: string) {
    return this.getQuery('Admin/datosBasicosTienda?tienda_id=' + idComercio);
  }
  getHorarios(idComercio: string) {
    return this.getQuery('pedidofoody/horariosxrepartot?tienda_id=' + idComercio);
  }

  getCategories(idComercio: string, salesCode: string, etiquetasCom: string) {
    if (idComercio === this.idSDCC) return this.getQuery(`Producto/listCategoriaSdcc?salesCode=${salesCode}`);
    else {
      let etiquetas = "('" + etiquetasCom.replace(",", "','") + "')";
      return this.getQuery(
        `Producto/listCategoriaWeb?` +
        `token=bot` +
        `&tienda_id=${idComercio}` +
        `&etiquetas=${etiquetas}` +
        `&etiqueta_id=${this.etiquetaComercio}` +
        `&producto_buscar=${this.filtroHtml}` +
        `&limit=50` +
        `&buscarxcodigo=0` +
        `&buscarxnombre=0` +
        `&buscarxdescripcion=0` +
        `&buscarxmarca=0`);
    }


  }
  getCategorySelected(idCategory: string) {
    this.categoryId = idCategory;
  }

  getProducts(idComercio, idCategoria, etiquetasCom: string, salesCode: string) {

    if (idComercio === this.idSDCC) {
      return this.getQuery(`Producto/getProductosByCategoriaSdcc?categoria=${idCategoria}&salesCode=${salesCode}`);
    } else {
      let etiquetas = "('" + etiquetasCom.replace(",", "','") + "')";
      return this.getQuery(
        `Producto/listByCategoriawebpos?` +
        `categoria_id=${idCategoria}` +
        `&tienda_id=${idComercio}` +
        `&etiqueta_id=${this.etiquetaComercio}` +
        `&etiquetas=${etiquetas}` +
        `&producto_buscar=${this.filtroHtml}` +
        `&pagina=1&` +
        `nregistro=100` +
        `&token=bot` +
        `&buscarxcodigo=0` +
        `&buscarxnombre=0` +
        `&buscarxdescripcion=0` +
        `&buscarxmarca=0`);

    }
  }
  createCliente(idComercio: string) {

    let params = {
      'tienda_id': idComercio,
      'email': this.emailCliente,
      'nombre': this.nombreCliente,
      'telefono': this.telefonoCliente
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
    });
    //console.log(params);
    //return this.http.post('https://api-dom.smallshi.com/cliente/insertarCliente',this.ObjecttoParams(params), {headers})
    return this.http.post(this.urlBase + 'cliente/insertarCliente', this.ObjecttoParams(params), { headers })
  }
  obtenerUrl(id: string) {
    return this.getQuery(`admin/getjsoncatalogo?id=${id}`);
  }

  crearPedido(pedido: string, idComercio: string) {
    console.log('pedido service', pedido);

    if (idComercio === this.idSDCC) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
      });
      //  return this.http.post(this.urlBase + 'Producto/hacerPedidoSdcc', pedido, { headers: headers });
      return this.http.post('Producto/hacerPedidoSdcc', pedido, { headers: headers });

    } else {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
      });
      //return this.http.post("https://api-dom.smallshi.com/pedido/newpedido3", pedido, {headers:headers});
      return this.http.post(this.urlBase + 'pedido/newpedido3', pedido, { headers: headers });
    }

  }

  getUrlPauService(idPedido: string, montoTotal: string, cantProductos: string, validar: boolean, tienda_id: string, nombre_tienda: string, Habitacion?: number) {
    var list;
    if (validar) {
      list = {
        'accion': 'urlACTIVA',
        'valores': {
          'tienda:id': tienda_id
        }
      };
    } else {
      list = {
        'accion': 'pedidoCompletado',
        'valores': {
          'tienda_id': tienda_id,
          'nombreComercio': nombre_tienda,
          'tipoTrasaccion': 'compra',
          'pedido': idPedido,
          'monto_total': montoTotal,
          'can_prod': cantProductos
        }
      };
      if (Habitacion) list['Habitacion'] = Habitacion;
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic c2lsaWNlcG9zOm1ZUFJ2dVAw'
    });

    let params = 'json=' + JSON.stringify(list) + '&url=' + this.urlPau;
    //console.log('parametros url: ',params);

    return this.http.post(this.urlBase + 'admin/retornarPAU', params, { headers: headers });
    //return this.http.post("https://api-dom.smallshi.com/admin/retornarPAU", params, {headers:headers});
  }
  datosTienda(tienda: string, telefono: string) {
    this.idTienda = tienda;
    this.tlfTienda = telefono;
  }
  saveCliente(codCliente) {
    this.codCliente = codCliente;
  }
  datosApi(id_cliente: string, urlPauFull: string, nombreCliente: string, emailCliente: string, telefonoCliente: string, urlRetorno: string, idJsonPau: string, flujo: string) {
    this.idCliente = id_cliente;
    this.urlPau = urlPauFull;
    this.nombreCliente = nombreCliente;
    this.emailCliente = emailCliente;
    this.telefonoCliente = telefonoCliente;
    this.urlRetorno = urlRetorno;
    this.idJsonPau = idJsonPau;
    this.flujo = flujo;

  }
  //----------------------------------------------------------//

  getPais(idPais: number) {
    return this.getQuery('consulta/obtenerpais?pais_id=' + idPais);
  }
  getProvincia(idPais: number) {
    return this.getQuery('consulta/obtenerProvincia?pais_id=' + idPais);
  }
  getDistrito(idProvincia: number) {
    return this.getQuery('consulta/obtenerDistrito?provincia_id=' + idProvincia);
  }
  getCorregimiento(idDistrito: number) {
    return this.getQuery('consulta/obtenerCorregimiento?distrito_id=' + idDistrito);
  }
  getBarrio(idCorregimiento: number) {
    return this.getQuery('consulta/obtenerBarrios?corregimiento_id=' + idCorregimiento);
  }
  geoCode(lat, lng) {
    // module AIzaSyB_RvE7EVkuVnnyycDHNQj3-tWsWnqtto0
    // index  AIzaSyB_RvE7EVkuVnnyycDHNQj3-tWsWnqtto0

    const KEY = "AIzaSyB_RvE7EVkuVnnyycDHNQj3-tWsWnqtto0";
    //https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=YOUR_API_KEY
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${KEY}`);

  }
  ObjecttoParams(obj) {
    var p = [];
    for (var key in obj) {
      p.push(key + '=' + encodeURIComponent(obj[key]));
    }
    return p.join('&');
  }

  getDistance(lat, lng) {
    var R = 6378137; //radio de la tierra en metros
    // console.log('datos de comercio lat:', this.tienda_lat, ' lng: ', this.tienda_lng);
    // console.log('datos de usuario lat:', lat, ' lng: ', lng);
    var dLat = this.rad(this.tienda_lat - lat);
    var dLong = this.rad(this.tienda_lng - lng);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.rad(lat)) * Math.cos(this.rad(this.tienda_lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  rad(x) {
    return x * Math.PI / 180;
  }
}
